// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import WelcomeLanding from './pages/WelcomeLanding';
import SalonProfile from './pages/SalonProfile';
import SalonAdmin from './pages/SalonAdmin';
// import SuperAdminCreateSalon from './pages/SuperAdminCreateSalon';
import './App.css';
// import { Routes, Route } from 'react-router-dom';
import SuperAdminCreateSalon from './components/SuperAdminCreateSalon';
import SuperAdminLogin from './components/SuperAdminLogin';
import SuperAdminRoute from './components/SuperAdminRoute';

function App() {
  return (
    <Router>
      <Routes>


        {/* روت لاگین سوپر ادمین */}
        <Route path="/admin/login" element={<SuperAdminLogin />} />

        {/* روت‌های محافظت‌شده سوپر ادمین */}
        <Route element={<SuperAdminRoute />}>
          <Route path="/" element={<SuperAdminCreateSalon />} />
        </Route>
        {/* صفحه اول: منحصراً فرم ثبت سالن توسط شما (مالک پلتفرم) */}
        {/* <Route path="/" element={<SuperAdminCreateSalon />} /> */}

        {/* صفحات عمومی و سالن‌ها */}
        <Route path="/salons/:slug" element={<WelcomeLanding />} />
        <Route path="/salons/:slug/profile" element={<SalonProfile />} />
        <Route path="/salons/:slug/admin" element={<SalonAdmin />} />

        {/* سایر مسیرها */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
